import clsx from 'clsx';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import { SkeletonRow } from '@components/skeleton';

const SkeletonDivDefault = ({ className }: { className?: string }) => (
  <SkeletonRow className={twMerge(clsx('mt-4 h-8 w-full', className))} />
);
export default SkeletonDivDefault;
